import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import { ConditionOperatorEnum, type Condition } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { OptionMenu } from '@/components/option-menu/option-menu';
import type { OptionType } from '@/components/option-menu/option-menu';
import { isGroup as _isGroup, type ConditionEditorOptions, type LocationIndicator } from './conditionEditorTypes';
export const ConditionMenu = t0 => {
  const $ = _c(119);
  const {
    condition,
    parent,
    options,
    onVisibilityChange,
    onChangeParent,
    markParentLocation
  } = t0;
  let t1;
  if ($[0] !== condition) {
    t1 = _isGroup(condition);
    $[0] = condition;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isGroup = t1;
  let t2;
  if ($[2] !== condition || $[3] !== parent.conditions) {
    t2 = parent.conditions?.findIndex(c => c === condition) ?? 0;
    $[2] = condition;
    $[3] = parent.conditions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const conditionIndex = t2;
  let t3;
  if ($[5] !== condition || $[6] !== onChangeParent || $[7] !== parent) {
    t3 = () => {
      onChangeParent({
        ...parent,
        conditions: parent.conditions?.filter(c_0 => c_0 !== condition) ?? []
      });
    };
    $[5] = condition;
    $[6] = onChangeParent;
    $[7] = parent;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onDelete = t3;
  let t4;
  if ($[9] !== condition || $[10] !== isGroup || $[11] !== onChangeParent || $[12] !== parent) {
    t4 = () => {
      const refOperator = isGroup ? condition.operator : parent.operator;
      const operator = refOperator === ConditionOperatorEnum.And ? ConditionOperatorEnum.Or : ConditionOperatorEnum.And;
      onChangeParent({
        ...parent,
        conditions: parent.conditions?.map(c_1 => c_1 === condition ? {
          operator,
          conditions: [c_1, {
            operator: ""
          }]
        } : c_1) ?? []
      });
    };
    $[9] = condition;
    $[10] = isGroup;
    $[11] = onChangeParent;
    $[12] = parent;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const onWrapWithGroup = t4;
  let t5;
  if ($[14] !== condition || $[15] !== conditionIndex || $[16] !== onChangeParent || $[17] !== parent) {
    t5 = index => {
      const conditions = parent.conditions?.slice() ?? [];
      conditions.splice(conditionIndex, 1);
      conditions.splice(index, 0, condition);
      onChangeParent({
        ...parent,
        conditions
      });
    };
    $[14] = condition;
    $[15] = conditionIndex;
    $[16] = onChangeParent;
    $[17] = parent;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const moveToIndex = t5;
  let t6;
  if ($[19] !== onChangeParent || $[20] !== parent) {
    t6 = index_0 => {
      const conditions_0 = parent.conditions?.slice() ?? [];
      conditions_0.splice(index_0, 0, {
        operator: ""
      });
      onChangeParent({
        ...parent,
        conditions: conditions_0
      });
    };
    $[19] = onChangeParent;
    $[20] = parent;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const addSibling = t6;
  let t7;
  if ($[22] !== markParentLocation) {
    t7 = () => markParentLocation?.(undefined);
    $[22] = markParentLocation;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== onWrapWithGroup || $[25] !== options.supportGrouping) {
    t8 = options.supportGrouping && {
      id: "create-group",
      text: "Create Group",
      icon: <i className="material-symbols-variable-add-outline w-[20px] h-[20px] mr-[8px]" />,
      menuItemProps: {
        onClick: onWrapWithGroup
      }
    };
    $[24] = onWrapWithGroup;
    $[25] = options.supportGrouping;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== options.supportGrouping) {
    t9 = options.supportGrouping && {
      divider: true,
      id: "divider-create-group"
    };
    $[27] = options.supportGrouping;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <i className="material-symbols-add-rounded w-[20px] h-[20px] mr-[8px]" />;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== conditionIndex || $[31] !== markParentLocation) {
    t11 = () => markParentLocation?.({
      index: conditionIndex,
      location: "above"
    });
    $[30] = conditionIndex;
    $[31] = markParentLocation;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== markParentLocation) {
    t12 = () => markParentLocation?.(undefined);
    $[33] = markParentLocation;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== addSibling || $[36] !== conditionIndex) {
    t13 = () => addSibling(conditionIndex);
    $[35] = addSibling;
    $[36] = conditionIndex;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t11 || $[39] !== t12 || $[40] !== t13) {
    t14 = {
      onMouseEnter: t11,
      onMouseLeave: t12,
      onClick: t13
    };
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <i className="material-symbols-vertical-align-top w-[20px] h-[20px] mr-[8px]" />;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t14) {
    t16 = {
      id: "add-condition-above",
      text: "Above",
      menuItemProps: t14,
      icon: t15
    };
    $[43] = t14;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== conditionIndex || $[46] !== markParentLocation) {
    t17 = () => markParentLocation?.({
      index: conditionIndex,
      location: "below"
    });
    $[45] = conditionIndex;
    $[46] = markParentLocation;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== markParentLocation) {
    t18 = () => markParentLocation?.(undefined);
    $[48] = markParentLocation;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== addSibling || $[51] !== conditionIndex) {
    t19 = () => addSibling(conditionIndex + 1);
    $[50] = addSibling;
    $[51] = conditionIndex;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== t17 || $[54] !== t18 || $[55] !== t19) {
    t20 = {
      onMouseEnter: t17,
      onMouseLeave: t18,
      onClick: t19
    };
    $[53] = t17;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <i className="material-symbols-vertical-align-bottom w-[20px] h-[20px] mr-[8px]" />;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== t20) {
    t22 = {
      id: "add-condition-below",
      text: "Below",
      menuItemProps: t20,
      icon: t21
    };
    $[58] = t20;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== t16 || $[61] !== t22) {
    t23 = {
      id: "add-condition",
      text: "Add Condition",
      icon: t10,
      subMenu: [t16, t22]
    };
    $[60] = t16;
    $[61] = t22;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  const t24 = `Move ${isGroup ? "Group" : "Condition"}`;
  let t25;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <i className="material-symbols-swap-vert-rounded w-[20px] h-[20px] mr-[8px]" />;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  const t26 = conditionIndex === 0;
  let t27;
  if ($[64] !== conditionIndex || $[65] !== markParentLocation) {
    t27 = () => markParentLocation?.({
      index: conditionIndex - 1,
      location: "above"
    });
    $[64] = conditionIndex;
    $[65] = markParentLocation;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== markParentLocation) {
    t28 = () => markParentLocation?.(undefined);
    $[67] = markParentLocation;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] !== conditionIndex || $[70] !== moveToIndex) {
    t29 = () => moveToIndex(conditionIndex - 1);
    $[69] = conditionIndex;
    $[70] = moveToIndex;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  if ($[72] !== t26 || $[73] !== t27 || $[74] !== t28 || $[75] !== t29) {
    t30 = {
      disabled: t26,
      onMouseEnter: t27,
      onMouseLeave: t28,
      onClick: t29
    };
    $[72] = t26;
    $[73] = t27;
    $[74] = t28;
    $[75] = t29;
    $[76] = t30;
  } else {
    t30 = $[76];
  }
  let t31;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <i className="material-symbols-arrow-warm-up w-[20px] h-[20px] mr-[8px]" />;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  let t32;
  if ($[78] !== t30) {
    t32 = {
      id: "move-condition-up",
      text: "Up",
      menuItemProps: t30,
      icon: t31
    };
    $[78] = t30;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  const t33 = conditionIndex === (parent.conditions?.length ?? 0) - 1;
  let t34;
  if ($[80] !== conditionIndex || $[81] !== markParentLocation) {
    t34 = () => markParentLocation?.({
      index: conditionIndex + 1,
      location: "below"
    });
    $[80] = conditionIndex;
    $[81] = markParentLocation;
    $[82] = t34;
  } else {
    t34 = $[82];
  }
  let t35;
  if ($[83] !== markParentLocation) {
    t35 = () => markParentLocation?.(undefined);
    $[83] = markParentLocation;
    $[84] = t35;
  } else {
    t35 = $[84];
  }
  let t36;
  if ($[85] !== conditionIndex || $[86] !== moveToIndex) {
    t36 = () => moveToIndex(conditionIndex + 1);
    $[85] = conditionIndex;
    $[86] = moveToIndex;
    $[87] = t36;
  } else {
    t36 = $[87];
  }
  let t37;
  if ($[88] !== t33 || $[89] !== t34 || $[90] !== t35 || $[91] !== t36) {
    t37 = {
      disabled: t33,
      onMouseEnter: t34,
      onMouseLeave: t35,
      onClick: t36
    };
    $[88] = t33;
    $[89] = t34;
    $[90] = t35;
    $[91] = t36;
    $[92] = t37;
  } else {
    t37 = $[92];
  }
  let t38;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <i className="material-symbols-arrow-cool-down w-[20px] h-[20px] mr-[8px]" />;
    $[93] = t38;
  } else {
    t38 = $[93];
  }
  let t39;
  if ($[94] !== t37) {
    t39 = {
      id: "move-condition-down",
      text: "Down",
      menuItemProps: t37,
      icon: t38
    };
    $[94] = t37;
    $[95] = t39;
  } else {
    t39 = $[95];
  }
  let t40;
  if ($[96] !== t32 || $[97] !== t39) {
    t40 = [t32, t39];
    $[96] = t32;
    $[97] = t39;
    $[98] = t40;
  } else {
    t40 = $[98];
  }
  let t41;
  if ($[99] !== t24 || $[100] !== t40) {
    t41 = {
      id: "move-condition",
      text: t24,
      icon: t25,
      subMenu: t40
    };
    $[99] = t24;
    $[100] = t40;
    $[101] = t41;
  } else {
    t41 = $[101];
  }
  let t42;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = {
      divider: true,
      id: "divider-condition"
    };
    $[102] = t42;
  } else {
    t42 = $[102];
  }
  const t43 = `Delete ${isGroup ? "Group" : "Condition"}`;
  let t44;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <i className="material-symbols-close-rounded w-[20px] h-[20px] mr-[8px]" />;
    $[103] = t44;
  } else {
    t44 = $[103];
  }
  let t45;
  if ($[104] !== onDelete) {
    t45 = {
      onClick: onDelete
    };
    $[104] = onDelete;
    $[105] = t45;
  } else {
    t45 = $[105];
  }
  let t46;
  if ($[106] !== t43 || $[107] !== t45) {
    t46 = {
      id: "delete-condition",
      text: t43,
      icon: t44,
      menuItemProps: t45
    };
    $[106] = t43;
    $[107] = t45;
    $[108] = t46;
  } else {
    t46 = $[108];
  }
  let t47;
  if ($[109] !== t23 || $[110] !== t41 || $[111] !== t46 || $[112] !== t8 || $[113] !== t9) {
    t47 = [t8, t9, t23, t41, t42, t46].filter(Boolean);
    $[109] = t23;
    $[110] = t41;
    $[111] = t46;
    $[112] = t8;
    $[113] = t9;
    $[114] = t47;
  } else {
    t47 = $[114];
  }
  const t48 = t47 as OptionType[];
  let t49;
  if ($[115] !== onVisibilityChange || $[116] !== t48 || $[117] !== t7) {
    t49 = <Tooltip title="Actions"><span><OptionMenu onOptionSelected={t7} onToggle={onVisibilityChange} options={t48} /></span></Tooltip>;
    $[115] = onVisibilityChange;
    $[116] = t48;
    $[117] = t7;
    $[118] = t49;
  } else {
    t49 = $[118];
  }
  return t49;
};